const faqs = [
  {
    q: '韩漫网上的韩漫全部免费吗？',
    a: '是的，韩漫网所有韩漫资源均可免费阅读，无需付费或会员订阅。我们致力于为广大韩漫爱好者提供零门槛的免费韩漫阅读体验，海量韩漫免费漫画任你畅读。',
  },
  {
    q: '什么是下拉式阅读？如何使用？',
    a: '下拉式阅读是一种流畅的纵向滚动阅读方式，您只需向下滑动页面即可连续阅读漫画内容，无需点击翻页按钮，阅读体验更加沉浸自然。韩漫网全站韩漫均支持下拉式在线阅读。',
  },
  {
    q: '韩漫网的漫画多久更新一次？',
    a: '韩漫网每日同步热门连载韩漫的最新章节，确保追更读者能够第一时间看到最新内容。部分热门韩漫免费漫画保持与韩国同步的更新节奏。',
  },
  {
    q: '如何投稿或推荐韩漫作品？',
    a: '欢迎通过联系投稿入口向我们推荐您喜爱的韩漫资源或原创作品。请前往页面底部的联系投稿模块查看具体方式，我们的内容团队会认真评估每一条推荐。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          常见问答
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}